import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {connect} from "react-redux";
import {Box, Grid, Button, Divider} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import {MoneyFormatter, DateFormatter} from "../../shared/formatter";
import {DashboardStyles} from "../../styles/dashboard";
import {isOfferApplied} from "../../store/actions/offers";
import {Topics} from "../../store/actions/messages";
import * as actions from "../../store/actions";

const useStyles = makeStyles(DashboardStyles);

const OfferDetailBox = (props) => {

    const classes = useStyles();
    const history = useHistory();
    let offers

    offers = props.vehicle ? props.vehicle.offers : null;
    if (offers && offers.length) {

        const buttonClickHandler = (event, offer) => {
            history.push('/dashboard/offers/' + offer.id);
        }

        const helpButton = offers.length > 0 ? (
            <Grid item xs={12} className={classes.helpButtonGrid}>
                <Button variant='outlined' color='primary' size='medium' onClick={props.onOpenMessageModel}>Get Help From Agent</Button>
            </Grid>
        ) : null;

        return (
            <Grid container justify='space-between' spacing={1}> 
                {offers.map((offer, idx) => {
                    const isItemApplied = isOfferApplied(offer);
                    const canSellerApply = offer && offer['actions'] && offer['actions']['canSellerApply'];

                    const divider = idx+1 < offers.length ? (
                        <Grid item xs={12} className={classes.dividerGrid}>
                                <Divider className={[ classes.divider ].join(' ')} />
                        </Grid>
                    ) : null;
                    
                    const expiresLine = isItemApplied ? 
                        (
                            <Box className={[classes.offerAcceptedBox, classes.colorWhite].join(' ')}>Offer Accepted!</Box>
                        ) :
                        (
                            <Box className={[classes.expiresAtBox, !canSellerApply ? classes.colorGrey : ''].join(' ')}>
                                Expires: {DateFormatter.stringDbDate2StringDate(offer.expiresAt)}</Box>
                        );
                    const acceptButton = !isItemApplied ?
                        (
                            <Button variant='contained' color='primary' size='medium' 
                                    onClick={(event) => buttonClickHandler(event, offer)}
                                    disabled={!canSellerApply}>DETAILS</Button>
                        ) : null;

                    return (
                        <React.Fragment key={idx}>
                            <Grid xs item>
                                <Box className={!isItemApplied && !canSellerApply ? 
                                    classes.offerAmountExpiredBox : classes.offerAmountBox}>{MoneyFormatter.format(offer.amount)}</Box>
                                <Box className={[classes.offerByClientBox, isItemApplied ? classes.colorWhite : 
                                        (  !canSellerApply ? classes.colorGrey : '' )].join(' ')}
                                    >By: {offer.clientName}</Box>    
                                {expiresLine}
                            </Grid>
                            <Grid item zeroMinWidth className={classes.offerAcceptButtonBox}>
                                {acceptButton}
                            </Grid>
                            {divider}
                        </React.Fragment>
                    );
                })}
                {helpButton}
            </Grid>
        )
    } else {
        return <React.Fragment>
            <Box>Offers received will be added here, please check back soon!</Box>
        </React.Fragment>
    }
}

const mapStateToProps = state => {
    return {
        account: state.account,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onOpenMessageModel: () => dispatch(actions.openMessageModal(Topics.CHOOSING_AN_OFFER_KEY)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OfferDetailBox);